var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",style:(_vm.vsize),attrs:{"aria-hidden":"true"},on:{"click":_vm.emitClick}},[_c('use',{attrs:{"xlink:href":'#icon-' + _vm.title}})])}
var staticRenderFns = []

export { render, staticRenderFns }